// @ts-nocheck
import {customAxios, Params} from "./customAxios";
import {BASE_URL} from "../redux/actions/dashboard/env.variables";

// start: primer dia del mes
// end: hoy
export const getDefaultDateObjs = () => {
  const now = new Date();
  return {
    start: now,
    end: now
  };
}

export const dateToShortDateString = (date: Date) => {
  return date?.toISOString().split('T')[0] ?? false;
}

export const getDefaultDates = () => {
  const {start, end} = getDefaultDateObjs();
  return {
    start: dateToShortDateString(start),
    end: dateToShortDateString(end)
  }
}

export const getMinMaxDate = (dateStart: Date, range: number) => {
  const dateBefore = new Date(new Date(dateStart).setDate(new Date(dateStart).getDate() - range))
  const dateAfter = new Date(new Date(dateStart).setDate(new Date(dateStart).getDate() + range))
  return {
    min: dateBefore,
    max: dateAfter,
  };
}

export const entriesToObj = (arr: any[]): any => {
  return arr.reduce((acc, curr) => {
    const [k, v] = curr;
    acc[`${k}`] = v;
    return acc;
  }, {});
}

export const downloadFile = (blob: any, filename: string = (new Date()).toISOString().split("T")[0], extension = ".zip") => {
  try {
    const objUrl = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = objUrl;
    link.download = filename + extension;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(objUrl);
  }catch (e){
    console.error(e);
  }
};

export const fetchBlob = (url: string, params: Params, requestMethod: string) => {
  const axios = customAxios(BASE_URL);
  axios.defaults.responseType = "blob";

  if (requestMethod !== "post" && requestMethod !== "get")
    throw new Error(`Only 'get' and 'post' requests implemented, got '${requestMethod}' instead`);

  const config = {
    headers: {
      "Access-Control-Allow-Origin": "*",
      "content-type": "application/json",
    }
  };

  const fun = requestMethod === "post"
      ? axios.post(url, params, config)
      : axios.get(url, params, config)

  return fun
      .then(res => {
        if (res.status !== 200){
          console.log(res.statusText, res.data);
          throw new Error(`Failed to fetch file ${res.statusText}`);
        }
        return res.data;
      })
      .then(blob => downloadFile(blob))
      .catch(err => console.error(err))
      .finally(() => {
        axios.defaults.responseType = "json";
      });
};

export const getCurrentTab = (): string => {
  return localStorage.getItem("currTab") || "orders";
}

export const setCurrentTab = (str: string): string => {
  localStorage.setItem("currTab", str);
}

export const clone = obj => JSON.parse(JSON.stringify(obj));

export const objectIsNullOrEmpty = obj => {
  return obj === null || obj === undefined || JSON.stringify(obj) === "{}";
}